<ion-content fullscreen>
  <ion-fab-button size="small" color="light" fill="solid" class="close" (click)="closeModal()">
    <ion-icon name="close"></ion-icon>
  </ion-fab-button>
  <swiper-container
    #swiper
    [pagination]="true"
    *ngIf="images && images.length > 0"
    (swiperslidechange)="slideChanged()"
  >
    <swiper-slide *ngFor="let image of images; let last = last">
      <ion-img [src]="image.url"></ion-img>
      <div class="button-wrapper" *ngIf="last">
        <ion-button fill="solid" shape="round" size="small" color="light" (click)="closeModal()">
          <span *ngIf="!last">Saltar</span>
          <span *ngIf="last">Cerrar</span>
        </ion-button>
      </div>
    </swiper-slide>
  </swiper-container>
  <div *ngIf="currentSlide > 0" class="backBtn" (click)="previousSlide()">
    <ion-icon name="ios-arrow-back"></ion-icon>
  </div>
  <div *ngIf="images && currentSlide < images.length - 1" class="nextBtn" (click)="nextSlide()">
    <ion-icon name="ios-arrow-forward"></ion-icon>
  </div>
</ion-content>
